import { action, observable } from 'mobx';
import { addToMap, HttpClient } from 'Mri.Web.Common';

export class DocumentsStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadDocumentsForAccountAsync(account: string) {
        const documents = await this.httpClient.get<Mri.Documents.DocumentModel[]>(`/api/v1/documents/${account}`, {
            cache: true,
        });

        addToMap(this.documents, documents, d => d.fileName);
    }

    @observable
    public documents = new Map<string, Mri.Documents.DocumentModel>();

    private readonly httpClient: HttpClient;
}
